import React, { useContext } from 'react'
import { DataContext } from '../../Context'
import './search.css'

function Search() {
  const {inputSearch, setInputSearch} = useContext(DataContext);
  return (
    <div className="header_search_container" >
        <input type="text" placeholder={"Buscar producto..."} onChange={(e)=>setInputSearch(e.target.value)} />
    </div>
  )
}

export default Search